export default __webpack_public_path__ + "static/media/carousel-right-green-btn-icon.b8b2b34a.svg";